import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Layouts
import AdminLayout from './admin/layout/AdminLayout';
import PublicLayout from './public/layout/PublicLayout';

// Admin Components
import ProductList from './admin/Dashboard/ShowTables/product/ProductList';
import OrderPageAdmin from './admin/Dashboard/ShowTables/order/Order';
import SalesDashboard from './admin/Dashboard/SalesDashboard';

// IMPORTAÇÃO DO COMPONENTE DE BANNERS
import BannerList from './admin/Dashboard/ShowTables/banner/BannerList';
import CouponsAdmin from './admin/Dashboard/CouponsAdmin';
import CategoriesAdmin from './admin/Dashboard/CategoriesAdmin';

// Public Components
import PublicProductPage from './public/pages/products/Page';
import ProductView from './public/pages/products/Details/ProductView';
import Home from './public/pages/home/home';
import FretePage from './public/pages/frete/frete';

import { CartProvider } from './context/CartContext';
import CartPage from './public/pages/cart/CartPage';
import LoginPage from './public/auth/pages/Login/LoginPage';
import RegisterPage from './public/auth/pages/Register/RegisterPage';
import ForgotPassword from './public/auth/pages/ForgotPassword/ForgotPassword';
import AboutUsPage from './public/pages/about/aboutUs';
import OrderPage from './public/pages/orders/order';
import Suporte from './public/pages/suporte/suporte';
import UserPage from './public/auth/pages/me/user';
import NotFoundPage from './public/pages/404/404';
import Privacidade from './public/pages/privacidade/privacidade';
import Termos from './public/pages/termos/termos';
import ResetPassword from './public/auth/pages/ResetPassword/ResetPassword';


function App() {
  return (

    <Router>
      <CartProvider>
        <Routes>
          {/* --- CONTEXTO ADMIN --- */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="products" />} />
            <Route path="products" element={<ProductList />} />
            <Route path="dashboard" element={<SalesDashboard />} />

            {/* ROTA DOS BANNERS ADICIONADA AQUI */}
            <Route path="banners" element={<BannerList />} />
            <Route path="categories" element={<CategoriesAdmin />} />
            <Route path="coupons" element={<CouponsAdmin />} />

            <Route path="orders" element={<OrderPageAdmin />} />
          </Route>

          {/* --- CONTEXTO PÚBLICO --- */}
          <Route path="/" element={<PublicLayout />}>
            <Route index element={<Home />} />
            <Route path="products" element={<PublicProductPage />} />
            <Route path="cart" element={<CartPage />} />
            <Route path="product/:id" element={<ProductView />} />
            <Route path="mostrar-frete" element={<FretePage />} />
            <Route path="about" element={<AboutUsPage />} />
            <Route path="my-orders" element={<OrderPage />} />
            <Route path="support" element={<Suporte />} />
            <Route path="my-account" element={<UserPage />} />
            <Route path="privacidade" element={<Privacidade />} />
            <Route path="termos" element={<Termos />} />
          </Route>

          {/* --- ROTAS SEM HEADER/FOOTER --- */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </CartProvider>
    </Router>

  );
}

export default App;